import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import { currentActorContextPropsStructure } from 'components/contexts/CurrentActor';
import { ProjectDocumentsContext } from 'components/contexts/ProjectDocumentsContext';
import ProjectDocumentsTab from 'components/projectDocuments/components/ProjectDocumentsTab';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper {...contextProps}>
        <ProjectDocumentsContext.Provider value={{ ...wrappedProps }}>
          <ProjectDocumentsTab />
        </ProjectDocumentsContext.Provider>
      </AppWrapper>
    </QueryClientProvider>
  );
}

EntryPoint.propTypes = {
  contextProps: PropTypes.shape({
    actors: PropTypes.exact(currentActorContextPropsStructure).isRequired,
  }),
  wrappedProps: PropTypes.shape({
    procoreProjectIntegration: PropTypes.shape({
      data: resourceShape('procoreProjectIntegration'),
    }),
    projectId: PropTypes.string.isRequired,
    projectPolicy: PropTypes.shape({
      canUpdate: PropTypes.bool.isRequired,
    }).isRequired,
    projectsPdfPolicy: PropTypes.shape({
      canDestroy: PropTypes.bool.isRequired,
    }).isRequired,
    riskAssessmentOnlyProjectPolicy: PropTypes.shape({
      canEdit: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
};
